import React from 'react';
import { Provider } from 'react-redux';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '../../../../App';
import { getStore } from '../../../../store/store';
import { useAorSitrep } from 'components/DisasterGPT/hooks/useSitrepsV2';
import { ReadOnlySitrepCard } from 'components/Reports/CurrentReportsSitrepCard';
import SitrepToggleSection from 'components/Reports/SitrepToggleSection';
import { TiptapRichTextEditor } from 'components/DesignSystems/New/TiptapRichTextEditor';

type AorPopupContentProps = {
  aorId: string;
  description: string;
};

const AorPopupContentInner: React.FC<AorPopupContentProps> = ({
  aorId,
  description,
}) => {
  const { data: aorSitrep } = useAorSitrep(aorId);

  return (
    <div style={{ maxWidth: '400px' }}>
      {description && (
        <div className="mb-3">
          <TiptapRichTextEditor
            value={description}
            readOnly
            showToolbar={false}
          />
        </div>
      )}
      {aorSitrep && (
        <SitrepToggleSection>
          <ReadOnlySitrepCard sitrep={aorSitrep} />
        </SitrepToggleSection>
      )}
    </div>
  );
};

const AorPopupContent: React.FC<AorPopupContentProps> = (props) => {
  const store = getStore();

  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <AorPopupContentInner {...props} />
      </QueryClientProvider>
    </Provider>
  );
};

export default AorPopupContent;
